document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bp-lightbox]').forEach(dialog => {
    if (dialog.dataset.ready === 'true') return;
    dialog.dataset.ready = 'true';
    const image = dialog.querySelector('img');
    const close = dialog.querySelector('[data-bp-lightbox-close]');
    const scope = dialog.parentElement;
    scope.querySelectorAll('[data-bp-lightbox-trigger]').forEach(trigger => trigger.addEventListener('click', () => {
      image.src = trigger.dataset.image;
      image.alt = trigger.dataset.alt;
      dialog.showModal();
      close.focus();
    }));
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
  });
});
